(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          
          // product carousel active
                      $('.product-carousel-2').slick({
                    		speed: 1000,
                    		autoplay: false,
                    		slidesToShow: 4,
                    		adaptiveHeight: true,
                    		prevArrow: '<span class="slick-btn slick-prev"><i class="dl-icon-left"></i></span>',
                    		nextArrow: '<span class="slick-btn slick-next"><i class="dl-icon-right"></i></span>',
                    		responsive: [{
                    			breakpoint: 992,
                    			settings: {
                    				slidesToShow: 4
                    			}
                    		},
                    		{
                    			breakpoint: 768,
                    			settings: {
                    				slidesToShow: 3,
                    				arrows: true
                    			}
                    		},
                    		{
                    			breakpoint: 480,
                    			settings: {
                    				slidesToShow: 1,
                    				arrows: true
                    			}
                    		}]
                    	});
                
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
